import { MailNotificationItem } from '../../model/MailNotificationItem';
import ServiceEndpoints from "../ServiceEndpoints"

export interface ReminderError {
  message: string;
  errors?: string[];
}

export async function fetchReminder(userId: string, userToken?: string): Promise<MailNotificationItem | ReminderError> {
    try {
        const response = await fetch(ServiceEndpoints.FetchReminder, {
            method: 'get',
            headers: { "Content-Type": "application/json", "Authorization": "Bearer " + userToken },
        });

        const data = await response.json();

        if (!response.ok) {
            // Handle 400 error with field errors
            if (response.status === 400 && data && data.errors && Array.isArray(data.errors)) {
                return {
                    message: "Validation error",
                    errors: data.errors
                };
            }

            throw new Error("Request failed with status: " + response.status);
        }

        return data as MailNotificationItem;
    } catch (error: any) {
        console.error("Error fetching reminder:", error);
        return {
            message: error.message || "Error fetching reminder"
        };
    }
}
export async function HandleUpdateReminder(newMailBody: string, userToken?: string): Promise<Response | ReminderError> {
    try {
        const response = await fetch(ServiceEndpoints.UpdateReminder, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json', "Authorization": "Bearer " + userToken
            },
            body: JSON.stringify(newMailBody),
        });

        if (response.ok) {
            console.log(`The Reminder has been updated successfully`);
            return response;
        } else {
            console.error(`Error on Reminder update`);

            try {
                // Try to parse the error response
                const errorData = await response.json();

                // Handle 400 error with field errors
                if (response.status === 400 && errorData && errorData.errors && Array.isArray(errorData.errors)) {
                    return {
                        message: "Validation error",
                        errors: errorData.errors
                    };
                }
            } catch (parseError) {
                // If we can't parse the response, just return a generic error
            }

            return {
                message: `Error updating reminder: ${response.status} ${response.statusText}`
            };
        }
    } catch (error: any) {
        console.error(`Error on Reminder update: ${error.message}`);
        return {
            message: error.message || "Error updating reminder"
        };
    }
}
